<template>
	<div class="home">
		<Encabezado></Encabezado>
		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div class="home-page">
					<div class="row">
						<ul class="menu-circles">
							<li v-if="permisoOpcion('PERMISOS')">
								<div class="circle bg-generalleave divHomeIcon" id="">
									<div class="countbadge"></div>
									<div class="daynum">
										<span v-if="numeroOpcion('PERMISOS') > 0" class=""> {{ numeroOpcion('PERMISOS') }} </span>
									</div>
									<router-link to="/permisos">
										<img src="../assets/iconos/icon-ausencias.png" />
										<em>Permisos Retribuidos y Ausencias</em>
									</router-link>
								</div>
							</li>
							<li v-if="permisoOpcion('VACACIONES')">
								<div class="circle bg-holidayleave divHomeIcon" id="">
									<div class="countbadge"></div>
									<div class="daynum">
										<span v-if="numeroOpcion('VACACIONES') > 0" class=""> {{ numeroOpcion('VACACIONES') }} </span>
									</div>
									<router-link to="/vacaciones">
										<img src="../assets/iconos/icon-vacaciones.png" />
										<em>Vacaciones</em>
									</router-link>
								</div>
							</li>
							<li v-if="permisoOpcion('ANTICIPOS')">
								<div class="circle bg-advancerequest divHomeIcon" id="">
									<div class="countbadge"></div>
									<div class="daynum">
										<span v-if="numeroOpcion('ANTICIPOS') > 0" class=""> {{ numeroOpcion('ANTICIPOS') }} </span>
									</div>
									<router-link to="/anticipos">
										<img src="../assets/iconos/icon-anticipo.png" />
										<em>Anticipos</em>
									</router-link>
								</div>
							</li>
							<li v-if="permisoOpcion('MOD_PERS')">
								<div class="circle bg-documents divHomeIcon" id="">
									<div class="countbadge"></div>
									<div class="daynum">
										<span v-if="numeroOpcion('MOD_PERS') > 0" class=""> {{ numeroOpcion('MOD_PERS') }} </span>
									</div>
									<router-link to="/modificaciones-datos-personales">
										<img src="../assets/iconos/icon-evaluacion.png" />
										<em>Modif. Datos Personales</em>
									</router-link>
								</div>
							</li>
							<li v-if="permisoOpcion('DOC_PERS')">
								<div class="circle bg-personaldocument divHomeIcon" id="">
									<div class="countbadge"></div>
									<div class="daynum">
										<span v-if="numeroOpcion('DOC_PERS') > 0" class=""> {{ numeroOpcion('DOC_PERS') }} </span>
									</div>
									<router-link to="/documentos-personales">
										<img src="../assets/iconos/icon-nominas.png" />
										<em>Documentos Personales</em>
									</router-link>
								</div>
							</li>
							<li v-if="permisoOpcion('DOC_GEN')">
								<div class="circle bg-documents divHomeIcon" id="">
									<div class="countbadge"></div>
									<div class="daynum">
										<span v-if="numeroOpcion('DOC_GEN') > 0" class=""> {{ numeroOpcion('DOC_GEN') }} </span>
									</div>
									<router-link to="/documentos-generales">
										<img src="../assets/iconos/icon-documentos.png" />
										<em>Documentos Generales</em>
									</router-link>
								</div>
							</li>
						</ul>
					</div>
					<div v-if="conDatos && !modoApp" id="Noticias-home">
						<div class="row">
							<div class="col-sm-12 col-md-12 text-center">
								<h1>Tablón de Anuncios</h1>

								<hr />
								<br />
							</div>
						</div>
						<div v-for="anuncio in anuncios" class="row">
							<div class="col-sm-12 col-md-12">
								<div class="media">
									<div class="media-left">
										<a href="#">
											<img alt="64x64" class="media-object" data-src="holder.js/64x64" style="width: 64px; height: 64px;" src="data:image/png;base64,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" data-holder-rendered="true">
										</a>
									</div>
									<div class="media-body">
										<router-link :to="`/anuncios/ver/${anuncio.id}`">
											<h3 class="media-heading">{{anuncio.attributes.titulo}}</h3>
										</router-link>
										<small><i>{{formatDate(anuncio.attributes.fecha_inicio)}}</i></small>
										<h5>{{anuncio.attributes.resumen}}</h5>
										<!--<p class="text-right">leer más...{{anuncio.id}}</p>-->
										<router-link :to="`/anuncios/ver/${anuncio.id}`">
											<p class="label label-info pull-right">leer más...</p>
										</router-link>
									</div>
								</div>
								<hr />
							</div>
						</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			
			<div v-if="mostrarModalApps">
				<transition name="modal">
					<div class="modal-mask">
						<div class="modal-wrapper">
							<div class="modal-dialog">
								<div class="modal-content">
									<div class="modal-header">
										<button type="button" class="close" @click="showModal = false">
										<span aria-hidden="true">&times;</span>
										</button>
										<h4 class="modal-title">¡Ya está disponible la App!</h4>
									</div>
									<div class="modal-body">
										<div class="row">
											<div class="col-12">
												<a target="_blank" href="https://play.google.com/store/apps/details?id=es.casi.empleados&hl=es_419">
													<img class="img-responsive" style="margin: 0 auto;" src="../assets/iconos/android.png" />
												</a>
											</div>
										</div>
										<div class="row" style="margin-top:20px;">
											<div class="col-12">
												<a target="_blank" href="https://apps.apple.com/us/app/empleados-casi/id6670555703">
													<img class="img-responsive" style="margin: 0 auto;" src="../assets/iconos/apple.png" />
												</a>
											</div>
										</div>
									</div>
									<div class="modal-footer">
										<button type="button" class="btn btn-default" @click="showModal = false">Cerrar</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>



			<Footer></Footer>
		</div>
	</div>
</template>

<script>

// @ is an alias to /src
import Encabezado from '@/components/Encabezado.vue'
import Footer from '@/components/Footer.vue'

export default {
	name: "Home",
	components: {
	  	Encabezado,
    	Footer
  	},
	data () {
		return{
			showModal: false
		}
	},
	mounted() {
		//const self = this;

		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");
		// console.log('---------------------------');
		// console.log(this.ultPaginaVisitada);
		// console.log('---------------------------');
		if (!this.conDatos){
			this.mostrarAvisoCargando();
		}
		if (this.ultPaginaVisitada != 'Login'){
			this.$store.dispatch('obtenerPerfil');
		}	
		this.$store.dispatch('obtenerAnuncios');
		
		this.showModal = true;
	},
	updated(){
		const self = this;

		if (this.conDatos){
			this.ocultarAvisoCargando();
		}
		
	},
	watch:{
		conDatos: function(val){
			//if (val) this.ocultarAvisoCargando();
			if (!val) this.mostrarAvisoCargando();
		}
	},
	methods:{
		permisoOpcion: function(iniciales){
			return this.opciones.some(opcion=>opcion.iniciales == iniciales);
		},
		numeroOpcion(iniciales){
			let numero = 0;
			
			if (iniciales == "DOC_GEN"){
				numero = this.$store.state.perfil.documentosGenerales.numero;
			}
			
			if (iniciales == "DOC_PERS"){
				if (this.$store.state.perfil.documentosPersonales){
					numero = this.$store.state.perfil.documentosPersonales.numero;
				}
			}

			return numero;
		},
		mostrarAvisoCargando: function(){
			this.$toast.open({
				message: "Cargando datos..., espere...",
				type: "info",
				dismissible: false,
				position: "top",
				duration: 10000
			});
		},
		ocultarAvisoCargando: function(){
			this.$toast.clear();
		},
		formatDate: function(date) {
			return this.moment(date).format('DD/MM/YYYY');
		}
	},
	computed:{
		opciones: function(){
			let opciones = [];
			
			if (this.$store.state.perfil.opciones){
				opciones = (Array.isArray(this.$store.state.perfil.opciones))?
				this.$store.state.perfil.opciones
				:
				[this.$store.state.perfil.opciones];
			}

			return opciones;
		},
		anuncios: function() {
			let anuncios = [];

			if (this.$store.state.anuncios) {
				anuncios = Array.isArray(this.$store.state.anuncios)
					? this.$store.state.anuncios
					: [this.$store.state.anuncios];
			}

			return anuncios;
		},
		conDatos: function(){
			return this.opciones.length;
		},
		ultPaginaVisitada: function(){
			return this.$store.state.ultPaginaVisitada;
		},
		modoApp: function(){
			return this.$store.state.modoApp;
		},
		mostrarModalApps: function(){
			//return false; //desactivación del modal con enlaces a las apps (android y apple).
			return (this.showModal && this.conDatos && !this.modoApp && this.ultPaginaVisitada == 'Login');
		}
		
	}
};
</script>

<style>
	@import "../assets/styles/home.css";
</style>
